const riot = require('riot');

riot.tag2('page-index', '<div>page-index</div>', 'page-index,[data-is="page-index"]{display:block}', '', function(opts) {
    this.preload = ({req, res}) => {
      if (!spat.isBrowser) return ;

      if (req.url === '/') {
        res.redirect(301, '/record');
        return;
      }
    };
});